import { USER_FORM } from '../form-portaluser-type';

/**
 * Function to display the admin access area
 * 
 * @returns void
 */
const DisplayPersArea = () => {
  return USER_FORM.userAccessContainer.innerHTML = `<div class="aafp_terminal-card aafp_border-radius">
                                                      <h4 class="aafp_customer-text">This user will have access to read only terminal data.</h4>
                                                    </div>`;
}

export default DisplayPersArea;